import cuid from "cuid";
import { ChangeEvent } from "react";

export function slugify(str: string, append?: number | undefined): string {
  const slug =
    str
      .trim()
      .normalize("NFKD")
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/[-\s]+/g, "-")
      // Prevent trailing dashes
      .replace(/\-+$/g, "") || cuid();

  if (append !== undefined) {
    return `${slug}${append}`;
  } else {
    return slug;
  }
}

export function slugifyChangeEvent(e: ChangeEvent<Element>): {
  target: { value: string };
} {
  return {
    target: {
      value: (e as ChangeEvent<HTMLInputElement>).target.value
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/[-\s]+/g, "-")
        .replace(" ", "-")
        .replace(/^-$/, ""),
    },
  };
}
